import React from 'react'
import Set_Left from './settingLeftFunction'
import Set_Top from './settingTop'
import './settingAPP.css'
import My_Info from './myInformation'
import Vip_Purchase from './vipPurchase'
import Pwd_Reset from './resetPwd'
import {fetchPost} from "../utils/fetchData";
import {convert_FormData_to_json2} from "../../config";
import {message} from "antd/lib/index";
import MD5 from 'md5'
import {showErrorMsg} from "../utils/commonFunc";

class SettingAPP extends React.Component {
    constructor(props) {
        super(props);
        this.state = ({
            myPageVisible:true,
            vipPurchseVisible:false,
            pwdVisible:false,
        });
        this.io = null;
        this.container = null;
    }

    handleShowMyPage = () => {
        this.myInfo.setNickNameText();
        this.setState({
            myPageVisible:true,
            pwdVisible:false,
        });
    };

    handleShowPwdResetPage = () => {
        this.setState({
            pwdVisible:true,
            myPageVisible:false,
        });
    };

    handleBack = () => {
        this.myInfo.setNickNameText();
        this.props.handleBack();
    };

    handleRecharge = () => {
        this.purchase.viewDidShow();
        this.setState({
            vipPurchseVisible:true,
        });
    };

    handleClosePurchase = () => {
        this.setState({
            vipPurchseVisible:false,
        })
    };

    bindPurchase = ref => (this.purchase = ref);

    bindMyInfo = ref =>(this.myInfo = ref);

    purchaseSuccessCallBack = () => {
        this.myInfo.getUserInfo();
    };

    modifyResetPwd = (oldPwd,newPwd) => {
        let formData = new FormData();
        formData.append("old_pwd", MD5(oldPwd));
        formData.append("new_pwd", MD5(newPwd));
        let retData = fetchPost('password',convert_FormData_to_json2(formData),null)
        retData.then(data => {
            if (data.code === 200) {
                message.success('密码修改成功');
            }
            else {
                showErrorMsg(data);
            }
        })
    };

    render(){
        let display = this.props.settingPageVisible?'block':'none';
        return(
            <div style={{display:display}} className='div_set_bottom_style'>
                <div style={{display:display}} className='div_set_bottom_style'>
                    <Set_Top handleBack={this.handleBack}/>
                    <Set_Left showPwdPage={this.handleShowPwdResetPage} showMyPage={this.handleShowMyPage}/>
                    <My_Info triggerRef={this.bindMyInfo} recharge={this.handleRecharge} infoVisible={this.state.myPageVisible} />
                    <Pwd_Reset submitModifyPwd={this.modifyResetPwd}  pwdVisible={this.state.pwdVisible}/>
                </div>
                <Vip_Purchase purchaseCallBack={this.purchaseSuccessCallBack} triggerRef={this.bindPurchase} closePage={this.handleClosePurchase} visible={this.state.vipPurchseVisible}/>
            </div>

        );
    }
}

export default SettingAPP